import Vue from 'vue';
import store from '../store'; // 假设你的权限列表存储在Vuex的store中


// 使用
{/* <button v-permission="['市局']">编辑</button> */}

//市、区、街道、社区
Vue.directive('permission', {
  inserted(el, binding) {
    const { value } = binding;
    const roles = store.getters.userInfo.DeptType; // 假设roles是用户的权限列表
    if (value && value instanceof Array && value.length > 0) {
      const permissionRoles = value;

      // 如果返回字段有多个权限
      // const hasPermission = roles.some(role => {
      //   return permissionRoles.includes(role);
      // });

      const hasPermission = permissionRoles.includes(roles);
      if (!hasPermission) {
        el.parentNode && el.parentNode.removeChild(el);
      }
    } else {
      throw new Error(`需要指定按钮权限标识！如v-permission="['市局','区局']"`);
    }
  }
});
